import Vue from 'vue'
import 'modules/certification-icons/certification-icons.vue'
import state from 'lib/appState'
import { handleize } from 'lib/util'

export const interpretTags = ({ tags, ...product }, acceptedFilters = []) => {
  for (let i = 0; i < tags.length; i++) {
    const tag = tags[i]
    if (
      acceptedFilters.find((accepted) => {
        return new RegExp(accepted, 'i').test(tag)
      })
    ) {
      const { name = '', value = '', error = false } = dehandelizeTag(tag)

      if (error) {
        continue
      }

      if (typeof product[name] === 'undefined') {
        product[name] = []
      }
      if (typeof product['tagNames'] === 'undefined') {
        product['tagNames'] = []
      }
      if (!~product['tagNames'].indexOf(name)) {
        product['tagNames'].push(name)
      }
      product[name].push(value)
    }
  }
  return { ...product, tags }
}

Vue.component('product-description', {
  props: ['productId'],
  data() {
    return {
      state,
      product: window.HU.product || [],
      activeAccordion: false,
      soloAccordion: false,
      icons: [],
      contents: [],
      factsContent: '',
    }
  },
  watch: {
    'state.activeVariant': {
      deep: true,
      handler(activeVariant) {
        this.$nextTick(() => {
          this.updateData(activeVariant)
        })
      },
    },
  },
  created() {
    const activeVariant = this.state.activeVariant
    this.updateData(activeVariant)
  },
  methods: {
    updateData(activeVariant) {
      const variantDefault = this.product.variants[0] || []
      this.icons =
        activeVariant.certificate_icons.length > 0 ? activeVariant.certificate_icons : variantDefault.certificate_icons
      this.contents = activeVariant.description.length > 0 ? activeVariant.description : variantDefault.description
      this.factsContent = activeVariant.view_facts_content || variantDefault.view_facts_content
      setTimeout(() => this.$forceUpdate(), 100)
    },
    toggleAccordion(reference) {
      if (this.soloAccordion) return null
      if (this.activeAccordion === reference) {
        this.activeAccordion = false
      } else {
        this.activeAccordion = reference
      }
    },
    height(reference) {
      if (this.activeAccordion !== reference) {
        return 0
      }
      if (!this.$refs[reference]) return null
      const heightAccordion = Array.isArray(this.$refs[reference])
        ? Number(this.$refs[reference][0].getBoundingClientRect().height) + 20
        : Number(this.$refs[reference].getBoundingClientRect().height) + 20
      return heightAccordion + 'px'
    },
    toggleDrawer(target) {
      this.state.activeDrawer = target
      this.state.modalToggleEl = document.activeElement
    },
  },
  mounted() {
    let counter = 0
    Object.keys(this.$refs).forEach((key) => {
      if (key.includes('accordion-')) {
        counter += 1
      }
    })
    this.soloAccordion = counter === 1
    setTimeout(() => {
      this.activeAccordion = 'accordion-1'
    }, 500)
  },
  computed: {
    isCustomBundle() {
      return handleize(this.product.type) === 'custom-bundle'
    },
    targetBundleProduct() {
      return this.state.bundleProducts.find((p) => p.id === String(this.productId))
    },
    activeVariant() {
      return this.state.activeVariant
    },
    certifications() {
      const product = this.isCustomBundle ? this.targetBundleProduct : this.product
      if (!product) return []
      const { certification = [] } = interpretTags(product, ['certification'])
      return certification
    },
  },
})
